import { render, staticRenderFns } from "./OtimizadorData.vue?vue&type=template&id=24361dd0&scoped=true"
import script from "./OtimizadorData.vue?vue&type=script&lang=js"
export * from "./OtimizadorData.vue?vue&type=script&lang=js"
import style0 from "./OtimizadorData.vue?vue&type=style&index=0&id=24361dd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24361dd0",
  null
  
)

export default component.exports